import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import { getMarketSlug } from './utils/market';
// import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';

axios.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  config.headers['X-Market-Slug'] = getMarketSlug();
  return config;
});

const crawlerContent = document.getElementById('crawler-content');
if (crawlerContent) {
  crawlerContent.remove();
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <CartProvider>
        <App />
      </CartProvider>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
